import React from 'react';
import { Table } from 'antd';
import ReducedData from '../../reducedData.json';
import dict from '../../dictionary';
import trans from '../../translations.json';
// import dataByPHU from '../../dataByPHU.json';
import IconChevronDown from '../../ds/icons/svg/ontario-icon-dropdown-arrow.svg';

class RegionalTable extends React.Component {
  state = {
    searchText: '',
    searchedColumn: '',
    data: undefined,
  };

  render() {
    //copy data coming in from props to a new object, remove some items that are too old, and build the new data for table

    var data = Object.values(ReducedData.dataPHU)
      .map((item) => {
        return {
          ...item,
          [dict.Reporting_PHU]:
            trans.PHU[item[dict.Reporting_PHU]][this.props.lang],
        };
      })
      .sort((a, b) =>
        a[dict.Reporting_PHU].localeCompare(b[dict.Reporting_PHU]),
      )
      .map((item, z) => {
        //console.log('item', item)
        return {
          ...item,
          index: z,
          [dict.resolved]:
            item[dict.resolved] &&
            item[dict.resolved].toLocaleString(),
          [dict.NotResolved]:
            item[dict.NotResolved] &&
            item[dict.NotResolved].toLocaleString(),
          [dict.deaths]:
            item[dict.deaths] && item[dict.deaths].toLocaleString(),
          total: (
            item[dict.resolved] +
            item[dict.NotResolved] +
            item[dict.deaths]
          ).toLocaleString(),
          [dict.new]: `<img src="
            ${IconChevronDown}"
            ${
              item[dict.yesterday] < item[dict.new] &&
              "style='transform: rotate(180deg)'"
            }
          }></img>${Math.abs(item[dict.new])}`,
        };
      });

    const columns = [
      {
        title: trans.reg.titletable[this.props.lang],
        dataIndex: dict.Reporting_PHU,
        key: dict.Reporting_PHU,
        width: '40%',
        //...this.getColumnSearchProps('name'),
      },
      {
        title: trans.viewModes.new[this.props.lang],
        dataIndex: dict.new,
        key: dict.new,
        width: '15%',
        render: (text) => {
          return (
            <div
              dangerouslySetInnerHTML={{
                __html: text,
              }}
            ></div>
          );
        },
        //...this.getColumnSearchProps('address'),
      },
      {
        title: trans.reg.active[this.props.lang],
        dataIndex: dict.NotResolved,
        key: dict.resolved,
        width: '15%',

        //...this.getColumnSearchProps('address'),
      },
      {
        title: trans.reg.resolved[this.props.lang],
        dataIndex: dict.resolved,
        key: dict.resolved,
        width: '15%',

        //...this.getColumnSearchProps('address'),
      },
      {
        title: trans.reg.deaths[this.props.lang],
        dataIndex: dict.deaths,
        key: dict.deaths,
        width: '15%',

        //...this.getColumnSearchProps('address'),
      },
      {
        title: trans.viewModes.all[this.props.lang],
        dataIndex: 'total',
        key: 'total',
        width: '15%',

        //...this.getColumnSearchProps('address'),
      },
    ];
    return (
      <Table
        columns={columns}
        dataSource={data}
        scroll={{ x: 300 }}
      />
    );
  }
}

export default RegionalTable;
